export default {
  SIDE_MENU: 'SideMenu',
  DASHBOARD: 'Dashboard',
  DASHBOARD_CLOSED: 'DashboardClosed',
  STAKE_CENTER_STAKED: 'PageStaked',
  STAKE_CENTER_COINBASE: 'PageCoinbase',
  STAKE_CENTER_MORE_ABOUT: 'PageMoreAboutStaking',
  HEADER_NOW: 'HeaderNow'
};
